import * as React from "react";
import type { SVGProps } from "react";

interface PenaltyKickProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const PenaltyKick = ({ cancelled = false, ...props }: PenaltyKickProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M1.07 6.47h20.76v12H1.07z" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M20.9 5.25c1.3 0 2.35 1.05 2.35 2.35v10.94c0 .69-.56 1.25-1.25 1.25h-.37c-.69 0-1.25-.56-1.25-1.25V8.12H3.62v10.42c0 .65-.5 1.18-1.12 1.24H2c-.69 0-1.25-.55-1.25-1.24V7.6c0-1.3 1.05-2.35 2.35-2.35z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M20.9 6c.88 0 1.6.72 1.6 1.6v10.94a.5.5 0 0 1-.5.5h-.37a.5.5 0 0 1-.5-.5V7.6c0-.13-.1-.23-.23-.23H3.1c-.13 0-.23.1-.23.23v10.94a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7.6c0-.88.72-1.6 1.6-1.6z"
      />
      <path
        fill="#007BBD"
        fillRule="nonzero"
        d="M6.34 16.88q-.6 0-.6-.6V11.8l-.6.38c-.38.23-.67.19-.88-.13-.1-.15-.13-.3-.1-.44.05-.14.16-.26.34-.35l1.14-.66a1.4 1.4 0 0 1 .82-.22c.32 0 .47.2.47.62v5.27c0 .41-.2.61-.59.61m4.16 0q-.6 0-.6-.6V11.8l-.6.38c-.38.23-.67.19-.88-.13-.1-.15-.13-.3-.1-.44.05-.14.16-.26.34-.35l1.14-.66a1.4 1.4 0 0 1 .82-.22c.32 0 .47.2.47.62v5.27c0 .41-.2.61-.59.61m3.1 0c-.45 0-.67-.2-.67-.6V11c0-.24.07-.4.2-.49.14-.08.33-.13.58-.13q.525 0 .78.42l1.64 2.64 1.62-2.63a.8.8 0 0 1 .37-.34q.21-.09.54-.09c.44 0 .66.2.66.62v5.26c0 .41-.22.61-.66.61q-.66 0-.66-.6v-3.8l-1.24 2.1c-.16.28-.37.42-.64.42-.26 0-.48-.14-.64-.42l-1.24-2.1v3.8c0 .4-.21.6-.65.6Z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default PenaltyKick;
